import { useCallback, useState } from 'react';

export const useEditorAll = () => {
    const [editiorAll, setEditorAll] = useState<boolean>(false);
    const handleEditorAll = useCallback(() => {
        setEditorAll((prev) => !prev);
    },[]);
    return { editiorAll, handleEditorAll };
};
